import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
//import Footer from "components/Footer/Footer.js";
import CustomFooter from "components/CustomFooter/CustomFooter.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import BlogList from "./BlogList.js";

import styles from "assets/jss/material-kit-pro-react/views/blogStyle.js";

const useStyles = makeStyles(styles);

export default function BlogPage() {
  const classes = useStyles();

  return (
    <div>
      <Header
        brand="WeVett Realty"
        links={<HeaderLinks dropdownHoverColor="primary" />}
        fixed
        color="transparent"
        changeColorOnScroll={{
          height: 80,
          color: "secondary"
        }}
      />
      
      <div className={classes.main}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={10} className={classes.mlAuto + " " + classes.mrAuto}>
              <BlogList />
            </GridItem>
          </GridContainer>
        </div>
      </div>
      
      <CustomFooter />
    </div>
  );
}